import { useState } from 'react'
import React from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts'
import { useTheme } from 'styled-components'
import biomassImg from './Assets/biomasse_oli.svg'
import solarImg from './Assets/solar_oli.svg'
import wasserImg from './Assets/wasserkraft_oli.svg'
import windImg from './Assets/wind_oli.svg'
import { formatDecimal } from '../../services/utils/format-numbers'

const ChartPieProducer = ({ energyData }) => {
  const theme = useTheme()

  const totalEnergyProduction = energyData?.data?.totalEnergyProduction
  const [allZeroData] = useState([
    { label: 'BIO_MASS', value: 0.0000001, image: biomassImg },
    { label: 'SOLAR_POWER', value: 0.0000001, image: solarImg },
    { label: 'HYDRO_POWER', value: 0.0000001, image: wasserImg },
    { label: 'WIND_ENERGY', value: 0.0000001, image: windImg },
  ])

  const transformedData = energyData?.data?.totalProductionByEnergySources
    ? [
        {
          label: 'BIO_MASS',
          value:
            (energyData?.data?.totalProductionByEnergySources?.BIO_MASS /
              totalEnergyProduction) *
            100,
          image: biomassImg,
        },
        {
          label: 'SOLAR_POWER',
          value:
            (energyData?.data?.totalProductionByEnergySources?.SOLAR_POWER /
              totalEnergyProduction) *
            100,
          image: solarImg,
        },
        {
          label: 'HYDRO_POWER',
          value:
            (energyData?.data?.totalProductionByEnergySources?.HYDRO_POWER /
              totalEnergyProduction) *
            100,
          image: wasserImg,
        },
        {
          label: 'WIND_ENERGY',
          value:
            (energyData?.data?.totalProductionByEnergySources?.WIND_ENERGY /
              totalEnergyProduction) *
            100,
          image: windImg,
        },
      ]
    : allZeroData

  const allZero = transformedData.every((item) => item.value === 0)

  const filteredData =
    allZero || !transformedData
      ? allZeroData
      : transformedData.filter((item) => item.value > 0)
  const dataToUse =
    energyData?.data?.totalProductionByEnergySources != null
      ? filteredData
      : allZeroData

  const CustomLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    value,
    index,
  }) => {
    const RADIAN = Math.PI / 180
    const radius = innerRadius + (outerRadius - innerRadius) * 1.7
    const x = cx + radius * Math.cos(-midAngle * RADIAN)
    const y = cy + radius * Math.sin(-midAngle * RADIAN)
    return (
      <g>
        <image
          href={dataToUse[index].image}
          x={x - 30}
          y={y - 10}
          width={24}
          height={24}
        />
        <text
          x={x + 20}
          y={y}
          fill={theme.tokens.secondary}
          textAnchor="middle"
          dominantBaseline="central"
        >
          {formatDecimal(value)}%
        </text>
      </g>
    )
  }

  const COLORS = {
    BIO_MASS: theme.tokens.primary,
    SOLAR_POWER: theme.tokens.customColorSignal,
    HYDRO_POWER: theme.tokens.secondaryFixedDim,
    WIND_ENERGY: theme.tokens.secondary,
    NETWORK: theme.tokens.outline,
  }

  return (
    <>
      <ResponsiveContainer width="90%" height={400}>
        <PieChart>
          <Pie
            data={dataToUse}
            cx="50%"
            cy="50%"
            labelLine={false}
            label={<CustomLabel />}
            outerRadius={110}
            innerRadius={60}
            fill="#8884d8"
            dataKey="value"
          >
            {dataToUse.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={
                  dataToUse === allZeroData
                    ? theme.tokens.outline
                    : COLORS[entry.label]
                }
              />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </>
  )
}

export default ChartPieProducer
